import _slicedToArray from "C:/Users/Administrator/Desktop/work/space-0/fsplus-vue-workspace/foshan-street/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "C:/Users/Administrator/Desktop/work/space-0/fsplus-vue-workspace/foshan-street/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "C:/Users/Administrator/Desktop/work/space-0/fsplus-vue-workspace/foshan-street/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/addr_icon.png';
import _imports_1 from '@/assets/componentImg/tag_icon.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-57c1dade"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "publish-container"
};
var _hoisted_2 = {
  class: "category-section line-section"
};
var _hoisted_3 = {
  key: 0,
  class: "nimin-fatie"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "label"
  }, "匿名发帖", -1);
});

var _hoisted_5 = {
  class: "submit-wrap"
};
var _hoisted_6 = {
  class: "btn-wrap"
};
var _hoisted_7 = {
  class: "add-btn"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_9 = {
  class: "add-btn"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_11 = /*#__PURE__*/_createTextVNode("提交");

var _hoisted_12 = {
  class: "content-declare-panel"
};
var _hoisted_13 = {
  class: "panel-header"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "panel-title"
  }, "内容声明设置", -1);
});

var _hoisted_15 = {
  class: "panel-body"
};
var _hoisted_16 = {
  class: "option-group"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "group-label"
  }, [/*#__PURE__*/_createTextVNode("合规声明 "), /*#__PURE__*/_createElementVNode("span", {
    class: "required-mark"
  }, "*必选")], -1);
});

var _hoisted_18 = ["onClick"];
var _hoisted_19 = {
  class: "option-name"
};
var _hoisted_20 = {
  class: "option-group"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "group-label"
  }, [/*#__PURE__*/_createTextVNode("风险提示 "), /*#__PURE__*/_createElementVNode("span", {
    class: "optional-mark"
  }, "可选")], -1);
});

var _hoisted_22 = ["onClick"];
var _hoisted_23 = {
  class: "option-name"
};
var _hoisted_24 = {
  class: "panel-footer"
};

var _hoisted_25 = /*#__PURE__*/_createTextVNode("确定");

import { reactive, ref, onMounted, computed } from 'vue';
import CPage from '@/views/CPage.vue';
import UploadView from '@/components/help/upload-view.vue';
import SelectLocationView from '@/components/help/select-location-view.vue';
import SelectTagView from '@/components/channel/select-tag-view.vue';
import throttle from 'lodash/throttle';
import composition from '@/composition';
import ua from '@/utils/platform';
import BindPhone from '@/components/common/bind-phone.vue';
import PublishForm from '@/components/publish/publish-form.vue';
/**
 * @typedef IConfigResultDataConfig
 * @prop {number} id
 * @prop {number} tagId
 * @prop {string} content
 * @prop {number} type
 * @prop {number} isRequire
 * @prop {any} picSize
 */

/**
 * @typedef IConfigResultData
 * @prop {number} tagId
 * @prop {number} isConfig
 * @prop {number} isSno
 * @prop {IConfigResultDataConfig[]} configList
 */

/**
 * @typedef IConfigResult
 * @prop {number} ret
 * @prop {string} msg
 * @prop {IConfigResultData} data
 * @prop {number} timestamp
 * @prop {any} pageData
 */

export default {
  setup: function setup(__props) {
    var _composition = composition(),
        store = _composition.store,
        request = _composition.request,
        fs_device = _composition.fs_device,
        getQueryString = _composition.getQueryString,
        openCustomPage = _composition.openCustomPage,
        wxShare = _composition.wxShare;

    store.dispatch('_initApp'); // 参数

    var query = getQueryString(); // 频道id

    var cid = ref(0); // 话题id

    var tid = ref(0);
    cid.value = query.cid;
    tid.value = query.tid;

    if (cid.value == 771) {
      tid.value = 2521;
    }

    if (cid.value == 795) {
      tid.value = 2590;
    } // 表单组件实例（表单渲染、弹窗、校验与提交均封装在 publish-form 内部）


    var publishFormRef = ref(null);
    onMounted(function () {
      wxShare(document.title);
    }); // 能否编辑话题

    var canEditTag = ref(true); // 频道

    var categroyItem = ref({
      id: 0
    }); // 上传图片

    var uploader = ref(null); // 表单

    var form = reactive({
      type: categroyItem.value.type,
      // 类型
      content: '',
      // 内容
      tagId: 0,
      // 话题
      address: '',
      // 地址
      location: '',
      // 经纬度
      tagName: '',

      /**@type {IConfigResult | null} */
      tagRes: null
    });
    var anonymous = ref(false); // 是否匿名发帖
    // 内容声明设置

    var contentDeclareShow = ref(false);
    var complianceStatement = ref('');
    var riskWarning = ref(''); // 合规声明类选项

    var complianceOptions = [{
      name: '含AI生成内容',
      value: 'AI'
    }, {
      name: '含虚构演绎内容',
      value: 'FICTION'
    }, {
      name: '内容含营销消息',
      value: 'MARKETING'
    }, {
      name: '内容为转载',
      value: 'REPOST'
    }, {
      name: '个人观点，仅供参考',
      value: 'PERSONAL_OPINION'
    }, {
      name: '内容无需标注',
      value: 'NONE'
    }]; // 风险提示类选项

    var riskWarningOptions = [{
      name: '内容可能引人不适，请谨慎观看',
      value: 'UNCOMFORTABLE'
    }, {
      name: '内容含有高危险行为，请勿模仿',
      value: 'HIGH_RISK'
    }, {
      name: '请理性适度消费',
      value: 'RATIONAL_CONSUMPTION'
    }, {
      name: '未成年人在监护人指导下浏览',
      value: 'MINOR'
    }]; // 判断是否上传了视频文件

    var hasVideo = computed(function () {
      var _uploader$value;

      var fl = ((_uploader$value = uploader.value) === null || _uploader$value === void 0 ? void 0 : _uploader$value.fileList) || [];
      return fl.some(function (item) {
        var _item$file, _item$file2;

        var type = ((_item$file = item.file) === null || _item$file === void 0 ? void 0 : _item$file.type) || '';
        var name = ((_item$file2 = item.file) === null || _item$file2 === void 0 ? void 0 : _item$file2.name) || '';
        if (type.indexOf('video/') !== -1) return true; // iOS/Android 常见视频扩展名兜底

        var videoExts = ['.mp4', '.mov', '.avi', '.wmv', '.flv', '.mkv', '.3gp', '.webm', '.m4v', '.ts'];
        if (videoExts.some(function (ext) {
          return name.toLowerCase().endsWith(ext);
        })) return true;
        return false;
      });
    }); // 内容声明设置右侧显示文本

    var contentDeclareLabel = computed(function () {
      if (!complianceStatement.value) return '请选择'; // 如果合规选择"内容无需标注"，且风险提示有选择 → 显示风险提示选项

      if (complianceStatement.value === 'NONE' && riskWarning.value) {
        var rw = riskWarningOptions.find(function (o) {
          return o.value === riskWarning.value;
        });
        return rw ? rw.name : '请选择';
      } // 其余情况显示合规声明选项


      var cs = complianceOptions.find(function (o) {
        return o.value === complianceStatement.value;
      });
      return cs ? cs.name : '请选择';
    }); // 选择合规声明

    function selectCompliance(value) {
      if (complianceStatement.value === value) {
        complianceStatement.value = '';
      } else {
        complianceStatement.value = value;
      }
    } // 选择风险提示


    function selectRiskWarning(value) {
      if (riskWarning.value === value) {
        riskWarning.value = '';
      } else {
        riskWarning.value = value;
      }
    } // 确定内容声明设置


    function onDeclareConfirm() {
      if (!complianceStatement.value) {
        _Toast('请选择合规声明');

        return;
      }

      contentDeclareShow.value = false;
    }

    function getCategoryOrTag() {
      return _getCategoryOrTag.apply(this, arguments);
    } // 话题是否配置了表单（只有 isConfig == 1 时才展示表单）


    function _getCategoryOrTag() {
      _getCategoryOrTag = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tagRes, categoryRes, res, _res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(tid.value && cid.value)) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 3;
                return request.getTimelineTag(tid.value);

              case 3:
                tagRes = _context2.sent;
                form.tagName = tagRes.data.name;
                form.tagId = tagRes.data.id;
                form.tagRes = tagRes;
                _context2.next = 9;
                return request.getTimelineCategory(cid.value);

              case 9:
                categoryRes = _context2.sent;
                categroyItem.value = categoryRes.data;
                _context2.next = 30;
                break;

              case 13:
                if (!tid.value) {
                  _context2.next = 25;
                  break;
                }

                // 获取话题详情
                canEditTag.value = false;
                _context2.next = 17;
                return request.getTimelineTag(tid.value);

              case 17:
                res = _context2.sent;
                categroyItem.value = res.category;
                categroyItem.value.canAnonymous = res.data.canAnonymous; // 特殊处理

                form.tagName = res.data.name;
                form.tagId = res.data.id;
                form.tagRes = res;
                _context2.next = 30;
                break;

              case 25:
                if (!cid.value) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 28;
                return request.getTimelineCategory(cid.value);

              case 28:
                _res = _context2.sent;
                categroyItem.value = _res.data;

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getCategoryOrTag.apply(this, arguments);
    }

    var formEnabled = function formEnabled() {
      var _form$tagRes, _form$tagRes$data;

      return ((_form$tagRes = form.tagRes) === null || _form$tagRes === void 0 ? void 0 : (_form$tagRes$data = _form$tagRes.data) === null || _form$tagRes$data === void 0 ? void 0 : _form$tagRes$data.isConfig) == 1;
    }; // 将获取表单设置到获取话题后执行


    getCategoryOrTag().then(function () {
      var _publishFormRef$value;

      return (_publishFormRef$value = publishFormRef.value) === null || _publishFormRef$value === void 0 ? void 0 : _publishFormRef$value.getFormConfig(tid.value, formEnabled());
    }); // 选择地址

    function selectLocation(item) {
      form.address = item ? item.title : '';
      form.location = item ? "".concat(item.point.lat, ",").concat(item.point.lng) : '';
    } // 选择话题


    function selectTag(item) {
      var _publishFormRef$value2;

      form.tagId = item ? item.id : 0;
      form.tagName = item ? item.name : '';
      (_publishFormRef$value2 = publishFormRef.value) === null || _publishFormRef$value2 === void 0 ? void 0 : _publishFormRef$value2.getFormConfig(form.tagId, formEnabled());
    } // 提交


    var onSubmit = throttle( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _publishFormRef$value3, _publishFormRef$value4, files, fl, params;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: 0
              }); // 表单校验（必填项未填写时组件内部会 throw）


              (_publishFormRef$value3 = publishFormRef.value) === null || _publishFormRef$value3 === void 0 ? void 0 : _publishFormRef$value3.validate(); // 内容声明设置验证（视频必填）

              if (!(hasVideo.value && !complianceStatement.value)) {
                _context.next = 6;
                break;
              }

              _Toast('请选择内容声明设置');

              throw {
                message: '请选择内容声明设置'
              };

            case 6:
              if (!((_publishFormRef$value4 = publishFormRef.value) !== null && _publishFormRef$value4 !== void 0 && _publishFormRef$value4.hasForm())) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return publishFormRef.value.commit();

            case 9:
              form.commitId = _context.sent;

            case 10:
              _context.next = 12;
              return uploader.value.uploadFunc();

            case 12:
              files = _context.sent;

              // 为视频文件添加内容声明字段
              if (hasVideo.value) {
                fl = uploader.value.fileList || [];
                fl.forEach(function (item, idx) {
                  var _item$file3, _item$file4;

                  var type = ((_item$file3 = item.file) === null || _item$file3 === void 0 ? void 0 : _item$file3.type) || '';
                  var name = ((_item$file4 = item.file) === null || _item$file4 === void 0 ? void 0 : _item$file4.name) || '';
                  var isVideo = type.indexOf('video/') !== -1 || /\.(mp4|mov|avi|wmv|flv|mkv|3gp|webm|m4v|ts)$/i.test(name);

                  if (isVideo && files[idx]) {
                    files[idx].complianceStatement = complianceStatement.value;

                    if (riskWarning.value) {
                      files[idx].riskWarning = riskWarning.value;
                    }
                  }
                });
              }

              params = _objectSpread(_objectSpread({}, form), {}, {
                categoryIds: [categroyItem.value.id],
                files: files,
                anonymous: anonymous.value
              }); // console.log(params)

              if (form.tagId) params.tagIds = [form.tagId];
              _context.next = 18;
              return request.savePost(params);

            case 18:
              _Toast.success('提交成功，等待审核'); // 有任务id
              // debugger


              if (query.taskId && (!query.tid || query.tid && tid.value == query.tid)) {
                onTaskSuccess('2');
              } else {
                goMain();
              }

              _poc_publish(params);

              _context.next = 26;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](0);

              _Toast.fail(_context.t0.message);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 23]]);
    })), 1000);

    function goMain() {
      setTimeout(function () {
        if (tid.value) {
          // 话题
          openCustomPage("topic/index.html?id=".concat(tid.value, "&fs_device=").concat(fs_device), true);
        } else {
          openCustomPage("channel/index.html?id=".concat(categroyItem.value.id, "&fs_device=").concat(fs_device), true);
        }
      }, 1000);
    }
    /**
     * query search 对象转字符串
     * @param {object} obj
     * @param {boolean} deleteEmpty 是否删除空值
     * @returns
     */


    function stringifyQuerySearch(obj) {
      var deleteEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var arr = [];
      Object.entries(obj).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        if (deleteEmpty && !value && value !== 0) {
          return;
        }

        arr.push("".concat(key, "=").concat(value));
      });
      return arr.join('&');
    } // 营销任务任务完成 taskType: 0-稿件分享、1-稿件评论、2-社区发站


    function onTaskSuccess(type) {
      var param = {};
      var search = window.location.search.split('?')[1];
      var arr = search.split('&');
      arr.forEach(function (i) {
        var _i$split = i.split('='),
            _i$split2 = _slicedToArray(_i$split, 2),
            key = _i$split2[0],
            value = _i$split2[1];

        param[key] = value;
      });
      var cid = param.cid;
      var taskId = param.taskId;
      var taskType = param.taskType;
      var collId = param.collId;
      var tid = param.tid;
      var memberId = param.memberId;
      if (!taskId) return;
      if (type !== taskType) return;
      var timer1 = setTimeout(function () {
        _Toast.success('完成任务!');

        clearTimeout(timer1);
      }, 800);
      var timer2 = setTimeout(function () {
        var taskQuery = stringifyQuerySearch({
          cid: cid,
          memberId: memberId,
          taskId: taskId,
          taskType: taskType,
          collId: collId,
          tid: tid
        });
        var url = "".concat(location.origin, "/fs-web-1/marketing-promotion-2024/#/award?").concat(taskQuery);
        location.replace(url);
        clearTimeout(timer2);
      }, 1500);
    }

    setTimeout(function () {
      if (localStorage.getItem('_user_id')) {
        // eslint-disable-next-line no-undef
        qaplus.event.setMetaInfo(localStorage.getItem('_user_id')); // eslint-disable-next-line no-undef

        pocplus.event.config('user_unique_id', localStorage.getItem('_user_id'));
      }
    }, 500);

    function _poc_publish(info) {
      var _poc_event_params = {
        post_channel: '友趣',
        member_id: localStorage.getItem('_user_id'),
        channel_id: info.channel_id,
        channel_name: categroyItem.value.name,
        topic_id: info.tagId,
        topic_name: info.tagName
      }; // eslint-disable-next-line no-undef

      qaplus.event.record('fsp_post_release', 19999, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record('fsplusmp_community_post_submit', _poc_event_params);
    }

    var isMini = computed(function () {
      return ua.isMini;
    });
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");

      var _component_van_switch = _resolveComponent("van-switch");

      var _component_van_cell = _resolveComponent("van-cell");

      var _component_van_button = _resolveComponent("van-button");

      var _component_van_form = _resolveComponent("van-form");

      var _component_van_icon = _resolveComponent("van-icon");

      var _component_van_popup = _resolveComponent("van-popup");

      return _openBlock(), _createBlock(CPage, {
        "is-publish": true
      }, {
        main: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, "发布在" + _toDisplayString(categroyItem.value ? categroyItem.value.name : ''), 1), _createVNode(UploadView, {
            ref_key: "uploader",
            ref: uploader,
            class: "line-section"
          }, null, 512), _createVNode(_component_van_form, {
            onSubmit: _unref(onSubmit)
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_field, {
                class: "line-section input-field",
                modelValue: _unref(form).content,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(form).content = $event;
                }),
                size: 'large',
                autosize: true,
                rows: "5",
                type: "textarea",
                maxlength: "500",
                placeholder: "请输入",
                "show-word-limit": "",
                rules: [{
                  required: true,
                  message: '请填写内容'
                }]
              }, null, 8, ["modelValue"]), categroyItem.value.canAnonymous == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createVNode(_component_van_switch, {
                modelValue: anonymous.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return anonymous.value = $event;
                }),
                size: "20px",
                "active-color": "#FF2340"
              }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _unref(hasVideo) ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 1,
                class: "content-declare-cell",
                "is-link": "",
                required: true,
                title: "内容声明设置",
                value: _unref(contentDeclareLabel),
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return contentDeclareShow.value = true;
                })
              }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(PublishForm, {
                ref_key: "publishFormRef",
                ref: publishFormRef
              }, null, 512), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [!_unref(isMini) ? (_openBlock(), _createBlock(SelectLocationView, {
                key: 0,
                onSelectLocation: selectLocation
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", null, _toDisplayString(_unref(form).address ? _unref(form).address : '添加定位'), 1)])];
                }),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(SelectTagView, {
                cid: categroyItem.value.id,
                canEdit: canEditTag.value,
                onSelectTag: selectTag
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", null, _toDisplayString(_unref(form).tagName ? _unref(form).tagName : '添加话题'), 1)])];
                }),
                _: 1
              }, 8, ["cid", "canEdit"])]), _createVNode(_component_van_button, {
                class: "submit-btn",
                "native-type": "submit"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_11];
                }),
                _: 1
              })])];
            }),
            _: 1
          }, 8, ["onSubmit"])]), _createVNode(BindPhone), _createVNode(_component_van_popup, {
            show: contentDeclareShow.value,
            "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
              return contentDeclareShow.value = $event;
            }),
            round: "",
            position: "bottom",
            style: {
              height: '90%'
            },
            "safe-area-inset-bottom": ""
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_van_icon, {
                name: "cross",
                size: "20",
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return contentDeclareShow.value = false;
                })
              })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(complianceOptions, function (item) {
                return _createElementVNode("div", {
                  key: item.value,
                  class: _normalizeClass(["option-item", {
                    selected: complianceStatement.value === item.value
                  }]),
                  onClick: function onClick($event) {
                    return selectCompliance(item.value);
                  }
                }, [_createElementVNode("span", _hoisted_19, _toDisplayString(item.name), 1), complianceStatement.value === item.value ? (_openBlock(), _createBlock(_component_van_icon, {
                  key: 0,
                  name: "success",
                  color: "#FF2340",
                  size: "18"
                })) : _createCommentVNode("", true)], 10, _hoisted_18);
              }), 64))]), _createElementVNode("div", _hoisted_20, [_hoisted_21, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(riskWarningOptions, function (item) {
                return _createElementVNode("div", {
                  key: item.value,
                  class: _normalizeClass(["option-item", {
                    selected: riskWarning.value === item.value
                  }]),
                  onClick: function onClick($event) {
                    return selectRiskWarning(item.value);
                  }
                }, [_createElementVNode("span", _hoisted_23, _toDisplayString(item.name), 1), riskWarning.value === item.value ? (_openBlock(), _createBlock(_component_van_icon, {
                  key: 0,
                  name: "success",
                  color: "#FF2340",
                  size: "18"
                })) : _createCommentVNode("", true)], 10, _hoisted_22);
              }), 64))])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_van_button, {
                class: "confirm-btn",
                block: "",
                onClick: onDeclareConfirm
              }, {
                default: _withCtx(function () {
                  return [_hoisted_25];
                }),
                _: 1
              })])])];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 1
      });
    };
  }
};